import { render, staticRenderFns } from "./StoreEditorSettings.vue?vue&type=template&id=60cdf035"
import script from "./StoreEditorSettings.vue?vue&type=script&lang=js"
export * from "./StoreEditorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports